export default function(keys) {
  $('#space-cow').off('clock').on('click', function() {
    window.COW.unlock("ef68f657-0ec6-474b-96fc-3672a76499b8", keys);
  });
}
